import { keepPreviousData } from "@tanstack/react-query";
import { useGetV4AdvReportTotals } from "./v4AdvReportTotals";

type Params = {
  adId: string | number;
};

type Options = {
  enabled?: boolean;
};

export const useAdTotals = ({ adId }: Params, { enabled = true }: Options = {}) => {
  const totalsOptionsGetter = useGetV4AdvReportTotals();
  const numericAdId = Number(adId);

  return {
    ...totalsOptionsGetter({
      filters: [
        {
          id: "ad_id",
          value: { op: "=", value: numericAdId },
        },
      ],
    }),
    enabled,
    placeholderData: keepPreviousData,
  };
};
